import { Image } from '@change/ds-core-ui';

import { useDecisionMakerResponseMedia } from './hooks/useDecisionMakerResponseMedia';

export function DecisionMakerResponseMedia() {
	const {
		data: { photo },
	} = useDecisionMakerResponseMedia();

	if (photo) {
		return (
			<div>
				<Image
					src={photo.url}
					aspectRatio="16:9"
					alt=""
					className="w-full rounded-md align-top md:w-[600px]"
					data-qa="dm-response-photo"
				/>
			</div>
		);
	}

	return null;
}
